import classnames from 'classnames';
import React from 'react';
import Helper from '../../../modules/Helper';

export interface IItemProps {
	keyword: string;
	type?: string;
	enabledVert: string;
	focused?: boolean;
	firstItem?: boolean;
	item: IAirportItem;
	onHover: () => void;
	onHoverClose: () => void;
	onSelect: (selectedItem: IAirportItem) => void;
}

export interface IAirportItem {
	name: string;
	allAirports?: boolean;
	iata?: string;
	type?: string;
	city?: string;
	state?: string;
	country: string;
	documentId: string;
	cityID?: string;
	airportID?: string;
	clicktripzHotelId?: string;
	kayakType?: string;
	ptid?: string;
	countryCode?: string;
	stateCode?: string;
	/** Optional canonical destcode (e.g. `C:12345`, `H:67890`, `CDG`) for SDK resolution */
	destcode?: string;
	/** Kayak / places-engine place id from autosuggest (numeric or `P` + digits); enables `-p…` landing URLs */
	placeId?: string;
	/**
	 * True when this destination was prepopulated from an explicit `?destcode=` URL param.
	 * Used to adjust redirect payloads (e.g. place-engine P codes) without affecting autosuggest picks.
	 */
	fromDestcodeParam?: boolean;
	// Optional original destination object from datadirects-platform (ResolvedDestination)
	// Used for SDK-based redirect building where available.
	resolvedDestination?: any;
}

const Item: React.FC<IItemProps> = (props) => {
	const replaceKeywordWithHighlight = (value: string, keyword: string) => {
		return Helper.replaceAll(value, keyword + '(?![^<>]*>)', function () {
			if (arguments.length) {
				return '<span class="highlight">' + arguments[0] + '</span>';
			}
		});
	};
	const searchKeyword = (value: string) => {
		let keyword = props.keyword;
		keyword = keyword.replace('(', '');
		keyword = keyword.replace(')', '');
		keyword = keyword.replace(' ', ',');
		// @ts-ignore
		keyword = keyword.split(',');
		// @ts-ignore
		keyword = keyword.filter((k) => {
			return k.length > 1;
		});
		for (let i = 0; i < keyword.length; i++) {
			let search = keyword[i];
			search = Helper.capitalize(search.trim());
			if (value !== undefined) {
				const currentLength = value.length;
				value = replaceKeywordWithHighlight(value, search);
				const newLength = value.length;
				if (newLength == currentLength) {
					// start replacing vowels characters
					const vowelsCharacters = ['a', 'e', 'i', 'o', 'u'];
					let founded = false;
					for (let i = 0; i < vowelsCharacters.length; i++) {
						if (founded) {
							break;
						}
						for (let j = 0; j < vowelsCharacters.length; j++) {
							const newSearch = search.replace(vowelsCharacters[i], vowelsCharacters[j]);
							value = replaceKeywordWithHighlight(value, newSearch);
							if (value.length != currentLength) {
								// Found the word
								founded = true;
								break;
							}
						}
					}
				}
			}
		}
		return value;
	};

	let { name, iata, city, country, state } = props.item;
	const enabledVert = props.enabledVert;
	const showIataInLabel = !!iata && (props.item.kayakType === 'ap' || props.item.type === 'airport');
	if (showIataInLabel) {
		name += ' (' + iata + ')';
	}
	if (props.firstItem) {
		name = Helper.trans('keywords.allAirports');
		if (showIataInLabel) {
			name += searchKeyword(' (' + iata + ')');
		}
	} else {
		name = searchKeyword(name);
	}
	let isCity = false;
	if (enabledVert === 'cars' && !iata) {
		isCity = true;
	}
	let type = props.type;
	if (isCity) {
		type = 'city';
	}

	const info = [];
	if (city) {
		info.push(searchKeyword(city));
	}
	if (state) {
		info.push(searchKeyword(state));
	}

	country = searchKeyword(country);
	info.push(country);

	return (
		<div
			onClick={() => props.onSelect(props.item)}
			className={classnames('item ' + type, {
				focused: props.focused,
			})}
			onMouseOver={props.onHover}
			onMouseOut={props.onHoverClose}
		>
			<div>
				<div
					dangerouslySetInnerHTML={{
						__html: name,
					}}
					className="name"
				/>
				<div
					dangerouslySetInnerHTML={{
						__html: info.join(', '),
					}}
					className="info"
				/>
			</div>
		</div>
	);
};

// @ts-ignore
const areEqual = (prevProps, nextProps) => {
	return Helper.shallowEqual(prevProps.item, nextProps.item) && nextProps.keyword === prevProps.keyword;
};

export default React.memo(Item, areEqual);
